module.exports = __webpack_public_path__ + "media/images/applicant/flow-dot-current-f522dbf6fbf564d442efd0aaa67d9718.svg";